import { useBareAssetAggregate } from '../contexts';
import { useFlattenFoldersFragment } from '../gql/generated/FlattenFolders';

/**
 * Returns true if flattenFolders setting is enabled for the current AssetAggregate (e.g. Collection).
 */
export function useIsFlattenFoldersEnabled() {
  const from = useBareAssetAggregate() ?? {};

  return (
    useFlattenFoldersFragment({
      from,
    }).data?.appearance?.flattenFolders ?? false
  );
}
